import React from "react";
import PrincipalFlowVerticalStepperElements from "../../constants/PrincipalFlowVerticalStepperElements";
import { FlowType } from "../../constants/FlowType";
import ReviewAndSignBase from "../shared/ReviewAndSign/ReviewAndSignBase";

export default function PrincipalReviewAndSign() {
    return (
        <ReviewAndSignBase
            flowType={FlowType.Principal}
            verticalStepperElements={PrincipalFlowVerticalStepperElements}
            currentStepperItem="Review, Sign and Submit"
            componentName="PrincipalReviewAndSign"
        />
    );
}


